import useHttpProvider from "@/common/hooks/use-http";
import { notifyError } from "@/components/ui/sonner";
import { useEffect, useState } from "react";
import * as LegalInformationServices from "../services/legal-information";

function useTermsAndConditions() {
	const { http } = useHttpProvider();

	const [content, setContent] = useState<string>("");

	const getTermsAndConditions = async () => {
		try {
			const response =
				await LegalInformationServices.getTermsAndConditions(http);
			setContent(response.content);
		} catch {
			notifyError("Terms and Conditions", "Failed to get Terms and Conditions");
		}
	};

	useEffect(() => {
		getTermsAndConditions();
	}, []);

	return {
		content,
	};
}

export default useTermsAndConditions;
